export default function fbTrack(a, b, c) {
  if (process.env.NODE_ENV === `production` && typeof fbq === `function`) {
    // eslint-disable-next-line no-undef
    fbq(a, b, c);
  }
}
